import {LogoutOutlined, UserOutlined} from "@ant-design/icons";
import {Avatar, Button, Dropdown, MenuProps} from "antd";
import {useGlobalState} from "app/user/GlobalStateProvider";
import {assertNotNil} from "app/util/stdlib";
import {Link, useNavigate} from "react-router";
import {linkHome, linkLogin} from "app/nav/links";

export const CurrentUserMenu = () => {
  const {isLoggedIn} = useGlobalState();
  if (isLoggedIn) {
    return <LoggedInUserMenu />;
  } else {
    return <NotLoggedInUserMenu />;
  }
};

const LoggedInUserMenu = () => {
  const {user, logoutUser} = useGlobalState();
  const navigate = useNavigate();
  assertNotNil(user);
  const prefix = user.email.substring(0, 2);
  const menuProps: MenuProps = {
    items: [
      {
        key: "1",
        icon: <UserOutlined />,
        label: "My Account"
      },
      {
        key: "2",
        label: "Logout",
        icon: <LogoutOutlined />,
        onClick: async () => {
          await logoutUser();
          navigate(linkHome());
        }
      }
    ]
  };
  return (
    <Dropdown menu={menuProps} placement="bottomRight">
      <Avatar className="bg-blue-600 cursor-pointer">{prefix.toUpperCase()}</Avatar>
    </Dropdown>
  );
};

const NotLoggedInUserMenu = () => {
  return (
    <Button color="geekblue" variant="solid">
      <Link to={linkLogin()}>Login</Link>
    </Button>
  );
};
